import React from 'react'
import Banner from "../../Components/Banner/HowItWorks"
import Main from "../../Components/HowItWorks/HowItWorks"
import Scroll from "../../Components/ScrollToTop"

function HowItWorks() {
  return (
    <div>
      <Scroll/>
      <Banner/>
      <Main/>
    </div>
  )
}

export default HowItWorks
